module.exports = "https://trybtryb-legacy.web.app/img/course.dd8a6614.svg";